import React from 'react'
import PaginationList from 'components/search/PaginationList'

export const MAX_SEARCH_RESULTS = 10000

const Pagination = ({
  paginationMode,
  pageLimit,
  pageNumber,
  resultsOnPage,
  resultCount: _resultsCount,
  getLink
}) => {
  if (paginationMode === 'all') return null
  const resultCount = Math.min(_resultsCount, MAX_SEARCH_RESULTS)
  const pageCount = Math.ceil(resultCount / pageLimit)

  return (
    <section>
      <Showing {...{ pageLimit, pageNumber, resultsOnPage, resultCount }} />
      <div className='flex lh-copy--spaced'>
        {pageLimit < resultCount && pageNumber > 1 && (
          <div className='flex items-center'>
            <Before {...{ pageNumber, getLink }} />
          </div>
        )}
        <PaginationList {...{ pageNumber, pageCount, getLink }} />
        {pageLimit < resultCount && pageNumber < pageCount && (
          <div className='flex items-center'>
            <After {...{ pageNumber, pageCount, getLink }} />
          </div>
        )}
      </div>
    </section>
  )
}

export default Pagination

const Showing = ({ pageLimit, pageNumber, resultsOnPage, resultCount }) => {
  let lowerLimit = pageLimit * (pageNumber - 1) + 1
  lowerLimit = Math.max(lowerLimit, 1)
  const upperLimit = lowerLimit + resultsOnPage - 1

  return (
    <div className='black f6 mb2'>
      Showing {lowerLimit}-{upperLimit} of {resultCount}
    </div>
  )
}

const Before = ({ pageNumber, getLink }) => (
  <>
    <a
      className='f6 black no-underline hover-underline hover-black dn-m'
      data-event-action='First Page'
      data-event-category='Search'
      href={getLink(1)}
      key='first'
    >
      &lt;&lt; First
    </a>
    <a
      className='f6 black ml5 no-underline hover-underline hover-black dn-m mr5'
      data-event-action='Previous Page'
      data-event-category='Search'
      href={getLink(pageNumber - 1)}
      key='prev'
    >
      &lt; Prev
    </a>
  </>
)

const After = ({ pageNumber, pageCount, getLink }) => (
  <>
    <a
      className='f6 black ml5 hover-black dn-m no-underline hover-underline'
      data-event-action='Next Page'
      data-event-category='Search'
      href={getLink(pageNumber + 1)}
      key='next'
    >
      Next ›
    </a>
    <a
      className='f6 black ml5 hover-black dn-m no-underline hover-underline'
      data-event-action='Last Page'
      data-event-category='Search'
      href={getLink(pageCount)}
      key='last'
    >
      Last »
    </a>
  </>
)
